const stickyAtc = document.querySelector('.section-sticky-atc');
const atcForm = document.querySelector("[data-type=add-to-cart-form]");

if (!stickyAtc || !atcForm) return;

init();

function init() {
    if (!stickyAtc.querySelector("button")) return;

    stickyAtc.querySelector("button").replaceWith(atcForm.querySelector(".product-form__submit:not(.hidden)").cloneNode(true));
    stickyAtc.querySelector("button").setAttribute("form", atcForm.getAttribute('id'));
    document.body.appendChild(stickyAtc);

    addEvents();
}

function addEvents() {
    stickyAtc.querySelector('button').addEventListener('click', (e) => {
        e.preventDefault();
        atcForm.querySelector(".product-form__submit:not(.hidden).button").click();
    });

    addObserver();

    atcForm.addEventListener('change', (e) => {
        stickyAtc.querySelector("button").replaceWith(atcForm.querySelector(".product-form__submit:not(.hidden)").cloneNode(true));
        stickyAtc.querySelector("button").setAttribute("form", atcForm.getAttribute('id'));
    });
}

function addObserver() {
    stickyAtc.classList.remove('section-sticky-atc--visible');
    const stickyAtcObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            const stickyAtcRect = stickyAtc.getBoundingClientRect();
            const atcFormRect = atcForm.getBoundingClientRect();
            if (stickyAtcRect.bottom < atcFormRect.top) {
                // If stickyAtc is above atcForm, do not add the class
                return;
            }

            if (entry.isIntersecting) {
                stickyAtc.classList.remove('section-sticky-atc--visible');
            } else {
                stickyAtc.classList.add('section-sticky-atc--visible');
            }
        });
    }, {
        root: null,
        threshold: 0.2
    });

    stickyAtcObserver.observe(atcForm);
}

